module.exports = __webpack_public_path__ + "static/media/San Mateo Ave San Bruno, CA1.71438c4b.jpg";